module.exports = __webpack_public_path__ + "static/media/profile-image2.ab45727a.png";